import React from 'react';
import { useDispatch } from 'react-redux';
import { createPortal } from 'react-dom';
import { PortalRoot, useRTL } from '@prezi/common-components';
import { ResponsiveModal, PageWrapper } from '../atoms/dumb';
import { ConfigContext } from '../../utils/config';
import { TOOLTIP_ROOT } from '../const';
import { actions } from '../../store/actions/actions';
const DEFAULT_MODAL_HEIGHT = 450;
const useElementHeight = ref => {
  const [height, setHeight] = React.useState(DEFAULT_MODAL_HEIGHT);
  React.useEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }
    const observer = new ResizeObserver(entries => {
      if (entries.length) {
        const [{
          contentRect
        }] = entries;
        setHeight(contentRect.height ?? DEFAULT_MODAL_HEIGHT);
      }
    });
    observer.observe(element);
    return () => {
      observer.disconnect();
    };
  }, [ref]);
  return height;
};
const Dialog = ({
  modalRootId,
  initialPage,
  children
}) => {
  const {
    isOpen
  } = React.useContext(ConfigContext);
  const {
    direction
  } = useRTL();
  const dispatch = useDispatch();
  const pageWrapperRef = React.useRef(null);
  const heightValue = useElementHeight(pageWrapperRef);
  React.useEffect(() => {
    if (isOpen && initialPage) {
      dispatch(actions.setPage(initialPage));
    }
  }, [isOpen, initialPage]);
  return createPortal(React.createElement("div", {
    dir: direction
  }, React.createElement(PortalRoot, {
    id: TOOLTIP_ROOT
  }), React.createElement(ResponsiveModal, {
    isOpen: isOpen,
    rootId: modalRootId,
    height: heightValue,
    isFixed: true,
    disableBackgroundScroll: true
  }, React.createElement(PageWrapper, {
    ref: pageWrapperRef
  }, children))), document.getElementById(modalRootId));
};
export default Dialog;